'use strict';

export let mainUrl = '';

// export const funcUrl = 'https://asap-mgmt-api-sb-tst.azurewebsites.net/api'; // Azure Functions-based API
export const funcUrl = 'https://asap-mgmt-api-tst.azurewebsites.net/api'; // Azure Functions-based API
//
export let mainUIUrl = 'https://appealsmgr-sb-test.azurewebsites.net/';

// export let eFileParodanUrl = 'https://aaefile.azurewebsites.net';            //  Legacy TEST System
// export const eFileParodanUrl = 'https://sbaaefile.azurewebsites.net';            //  Legacy SB PROD System
export let eFileParodanUrl = 'https://asap-mgmt-api-sb-tst.azurewebsites.net/api'; //  for printing efile application;

export let auth0RedirectUrl = 'https://appealsmgr-sb-test.azurewebsites.net/';    // TEST - redirect URL when user is registering for first time
//
export let eFileUrl = 'https://asap-efile-tst.azurewebsites.net/api';
export let tokenUrl = 'https://asap-efile-tst.azurewebsites.net/token';
export let efilePrintService: 'https://EfilePrint-test.azurewebsites.net';  // NOT used in this version of the app!
//
export const inactivityMinutes = 120;        // # of minutes allowed of user inactivity prior to forced logoff!
export const backLogYear = 10;                // # of years to go back; used to populate RollYear dropdown in case mod
export const authProvider = 1;                 // 0 = Auth0, 1 = Azure Active Directory, 2 = other
//
/// FLAGS USED TO CONTROL UI BEHAVIOR, i.e. enabling/hiding options/buttons, allowing selection of old hearing dates, etc
export let allowOldHearings = false; // allow/disallow selecting old Hearing Dates (prior to today's date); used primarily to allow backloading of cases
export let allowAPNLookup = true;   // display button to view Assessor/APN data
export let allowAssessorValues = true;   // display button to retrieve Assessor property values
export let allowCaseBackload = true;     // allows backloading of (old) cases
export let showDashboardMode = 0;         // 0 = do not show charts, 1 = show CoB charts, 2 = show ALL charts
export let showAgendaPacket = 1;          // 1 = make Packet option available, 0 = option is not available
// version#, connection flags, audit trail, etc
export const versionNum = '2.4.2';
export let localApiEnv = 0;
export let isSBAzure = true;          // calls to API are directed to SB County's own Azure PROD environment
export let isSBAzureTEST = false;      // calls to API are directed to SB County's TEST system
export let isParodanTestSystem = false;     // calls to API are directed to Parodan's TEST environment, display in Home page
export let auditFlag = false;  // determine if calls to doAudit method, in UtilitiesService class, will send messages to console.log
//
// E-File related settings
export let sbProdEfile = true;         // allow access to SB PROD (Legacy) E-Filing data
export let allowEFileImport = true;     // allows importing of E-filed applications
export let allowEfileRejection = false;  // allows rejection of E-Filed applications
//
// Azure (Entra/Active Directory) related variables
export let clientIdUI = '23c6ef77-46fb-46e5-aa87-69f916f735aa'; // Registration ID for the API (sb-tst)
export let authority = 'https://login.microsoftonline.com/07eb5e9b-e5ac-44f0-82c1-baa275302579';  // TENANT ID
export let AzureApiUrl = 'api://23c6ef77-46fb-46e5-aa87-69f916f735aa/User.RunApp'; // API clientId/scope (sb-tst)
//
// Set environment, i.e. if we're running against the TEST system, return the corresponding Urls
export function setEnv(): any {
  let envObj = {
    mainUrl,
    funcUrl,
    mainUIUrl,
    auth0RedirectUrl,
    tokenUrl,
    eFileParodanUrl,
    eFileUrl,
    efilePrintService,
    auditFlag,
    sbProdEfile,
    authProvider,
    showDashboardMode,
    showAgendaPacket,
    isSBAzure,
    clientIdUI,
    authority,
    AzureApiUrl,
    backLogYear
  };
  if (isSBAzure === true) {  // we're connecting to the SB Azure tenant (i.e. NOT Parodan); change resources
    envObj.funcUrl = 'https://asap-mgmt-api-sb-p.azurewebsites.net/api';   // SB PROD func API
    envObj.mainUIUrl = 'https://appealsmgr-sb-p.azurewebsites.net';  // SB PROD UI
    envObj.clientIdUI = 'd846955c-194a-4b2d-983f-676edca11e7c'; // Registered UI Client ID
    envObj.authority = 'https://login.microsoftonline.com/e64b3773-9890-4a2f-87cd-23725df35ace';  // Tenant ID
    envObj.AzureApiUrl = 'api://b26197a4-86af-4382-833a-a645b3d2c9f4/User.RunApp';  // ref API Client ID
  } else if (isSBAzureTEST === true) {  // we're connecting to the SB Azure tenant (i.e. NOT Parodan); change resources
    envObj.funcUrl = 'https://asap-mgmt-api-sb-qa.azurewebsites.net/api';   // SB TEST func API
    envObj.mainUIUrl = 'https://appealsmgr-sb-qa.azurewebsites.net';  // SB TEST UI
    envObj.clientIdUI = 'd846955c-194a-4b2d-983f-676edca11e7c'; // Registered UI Client ID
    envObj.authority = 'https://login.microsoftonline.com/e64b3773-9890-4a2f-87cd-23725df35ace';  // Tenant ID
    envObj.AzureApiUrl = 'api://b26197a4-86af-4382-833a-a645b3d2c9f4/User.RunApp';  // ref API Client ID
  }

  // if we want to connect to the SB PROD E-File system, change some urls...
  if (sbProdEfile === true) { // connect to the SB PROD efile system; used by Efile Manager module
    envObj.eFileUrl = 'https://sbc-aa-efile-ws.azurewebsites.net/api/v1/efile';   //  SB PROD System
    envObj.tokenUrl = 'https://sbc-aa-efile-ws.azurewebsites.net/token';          //  SB PROD System
    envObj.eFileParodanUrl = 'https://sbaaefile.azurewebsites.net';               //  SB PROD E-File System
  }
  // change url, if appropriate, based on which environment API is running (published site/local)
  if (localApiEnv === 0) {
    // running against a published site, so the funcUrl should have already been set to the correct value, above!
  } else if (localApiEnv === 1) {
    envObj.funcUrl = 'http://localhost:7071/api';   // we're running API locally, in Rider
  } else if (localApiEnv === 2) {
    envObj.funcUrl = 'http://localhost:5001/api';   // we're running API locally, in VS Code
  } else if (localApiEnv === 3) {
    envObj.funcUrl = 'http://localhost:7071/api';   // we're running API locally, in Visual Studio
  }
  return envObj;
}
